import {RESTController} from './controllers/RESTController';
import {LocalDatabaseController} from './controllers/LocalDatabaseController';

let _RESTController = new RESTController();
let _LocalDatabaseController = new LocalDatabaseController();

class APIController {

    static fileUploadDropzoneUrl() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.fileUploadDropzoneUrl();
        else
            return _RESTController.fileUploadDropzoneUrl();
    }

    static manageReturnedData(returnedData, defaultData) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.manageReturnedData(returnedData, defaultData);
        else
            return _RESTController.manageReturnedData(returnedData, defaultData);
    }

    static async getFanTypeList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getFanTypeList();
        else
            return await _RESTController.getFanTypeList();
    }

    static async getAppPathsList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getAppPathsList();
        else
            return await _RESTController.getAppPathsList();
    }

    static async getMaterialSortList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getMaterialSortList();
        else
            return await _RESTController.getMaterialSortList();
    }

    static async getAppPathsFanTypesList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getAppPathsFanTypesList();
        else
            return await _RESTController.getAppPathsFanTypesList();
    }

    static async getAppPathsParametersSettingsList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getAppPathsParametersSettingsList();
        else
            return await _RESTController.getAppPathsParametersSettingsList();
    }

    static async getAppTableParametersSettingsList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getAppTableParametersSettingsList();
        else
            return await _RESTController.getAppTableParametersSettingsList();
    }

    static async getAppPathsWorkPointsSettingsList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getAppPathsWorkPointsSettingsList();
        else
            return await _RESTController.getAppPathsWorkPointsSettingsList();
    }

    static async getAppFansImagesList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getAppFansImagesList();
        else
            return await _RESTController.getAppFansImagesList();
    }

    static async getFanSortList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getFanSortList();
        else
            return await _RESTController.getFanSortList();
    }

    static async getFansAtexTypes() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getFansAtexTypes();
        else
            return await _RESTController.getFansAtexTypes();
    }

    static async getLanguagesList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getLanguagesList();
        else
            return await _RESTController.getLanguagesList();
    }

    static async getTranslationsList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getTranslationsList();
        else
            return await _RESTController.getTranslationsList();
    }

    static async getUnitsList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getUnitsList();
        else
            return await _RESTController.getUnitsList();
    }

    static async getUnitTypesList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getUnitTypesList();
        else
            return await _RESTController.getUnitTypesList();
    }

    static async getMeasurementsList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getMeasurementsList();
        else
            return await _RESTController.getMeasurementsList();
    }

    static async sendMaterialRequest(data) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.sendMaterialRequest(data);
        else
            return await _RESTController.sendMaterialRequest(data);
    }

    static async getFansOfPath(id_app_fan_type, id_app_fan_sort) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getFansOfPath(id_app_fan_type, id_app_fan_sort);
        else
            return await _RESTController.getFansOfPath(id_app_fan_type, id_app_fan_sort);
    }

    static async getFanCharacteristicsList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getFanCharacteristicsList();
        else
            return await _RESTController.getFanCharacteristicsList();
    }

    static async getFansTypesList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getFansTypesList();
        else
            return await _RESTController.getFansTypesList();
    }

    static async getConnectionsList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getConnectionsList();
        else
            return await _RESTController.getConnectionsList();
    }

    static async getEngineStartupList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getEngineStartupList();
        else
            return await _RESTController.getEngineStartupList();
    }

    static async getOctaveNoiseList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getOctaveNoiseList();
        else
            return await _RESTController.getOctaveNoiseList();
    }

    static async loginUser(data) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.loginUser(data);
        else
            return await _RESTController.loginUser(data);
    }

    static async registerUser(data) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.registerUser(data);
        else
            return await _RESTController.registerUser(data);
    }

    static async verifyUser(data) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.verifyUser(data);
        else
            return await _RESTController.verifyUser(data);
    }

    static async getDefaultManufacturer() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getDefaultManufacturer();
        else
            return await _RESTController.getDefaultManufacturer();
    }

    static async getEnginesList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getEnginesList();
        else
            return await _RESTController.getEnginesList();
    }

    static async getPricesList() {
        let userToken = this.getUserToken();
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getPricesList(userToken);
        else
            return await _RESTController.getPricesList(userToken);
    }

    static async getCurrenciesList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getCurrenciesList();
        else
            return await _RESTController.getCurrenciesList();
    }

    static async getFansExtrasList() {
        if(this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getFansExtrasList();
        else
            return await _RESTController.getFansExtrasList();
    }

    static async getFansAtexesList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getFansAtexesList();
        else
            return await _RESTController.getFansAtexesList();
    }

    static async getRelationsFanAtexes() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getRelationsFanAtexes();
        else
            return await _RESTController.getRelationsFanAtexes();
    }

    static async getRelationsFanVersionsExtrasList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getRelationsFanVersionsExtrasList();
        else
            return await _RESTController.getRelationsFanVersionsExtrasList();
    }

    static async getFansPositionsList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getFansPositionsList();
        else
            return await _RESTController.getFansPositionsList();
    }

    static async getRelationsFanTypesPositionsList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getRelationsFanTypesPositionsList();
        else
            return await _RESTController.getRelationsFanTypesPositionsList();
    }

    // NVS-91
    static async getSettingsFullList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getSettingsFullList();
        else
            return await _RESTController.getSettingsFullList();
    }

    static async getVariablesFullList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getVariablesFullList();
        else
            return await _RESTController.getVariablesFullList();
    }

    static async getFansVersionsList() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getFansVersionsList();
        else
            return await _RESTController.getFansVersionsList();
    }

    static async getFanByTypeNumber(data) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getFanByTypeNumber(data);
        else
            return await _RESTController.getFanByTypeNumber(data);
    }

    static async getFanByTypeNumberHandshake(data) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getFanByTypeNumberHandshake(data);
        else
            return await _RESTController.getFanByTypeNumberHandshake(data);
    }

    static async sendOffer(data) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.sendOffer(data);
        else
            return await _RESTController.sendOffer(data);
    }

    static async approveOffer(data) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.approveOffer(data);
        else
            return await _RESTController.approveOffer(data);
    }

    static async cancelOffer(data) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.cancelOffer(data);
        else
            return await _RESTController.cancelOffer(data);
    }

    static async checkUserToken(data) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.checkUserToken(data);
        else
            return await _RESTController.checkUserToken(data);
    }

    static async getFanRender(data) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getFanRender(data);
        else
            return await _RESTController.getFanRender(data);
    }

    static async getSinglePdf(data) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getSinglePdf(data);
        else
            return await _RESTController.getSinglePdf(data);
    }

    static async postResetPassword(data) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.postResetPassword(data);
        else
            return await _RESTController.postResetPassword(data);
    }

    static async postRequestPasswordReset(data) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.postRequestPasswordReset(data);
        else
            return await _RESTController.postRequestPasswordReset(data);
    }

    static async getOfferSurchargesOptions() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getOfferSurchargesOptions();
        else
            return await _RESTController.getOfferSurchargesOptions();
    }

    // NVS-95
    static async getOfferDiscountsOptions() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getOfferDiscountsOptions();
        else
            return await _RESTController.getOfferDiscountsOptions();
    }

    // NVS-152
    static async getOfferAntiCorrosionOptions() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getOfferAntiCorrosionOptions();
        else
            return await _RESTController.getOfferAntiCorrosionOptions();
    }

    static async getOffersOfUser() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getOffersOfUser();
        else
            return await _RESTController.getOffersOfUser();
    }

    static async getOfferOfId(data) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getOfferOfId(data);
        else
            return await _RESTController.getOfferOfId(data);
    }

    static async getOfferOfServerId(data) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getOfferOfServerId(data);
        else
            return await _RESTController.getOfferOfServerId(data);
    }

    static async removeFileFromServer(data) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.removeFileFromServer(data);
        else
            return await _RESTController.removeFileFromServer(data);
    }

    static async getTemperatureRangesWithManufacturers() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getTemperatureRangesWithManufacturers();
        else
            return await _RESTController.getTemperatureRangesWithManufacturers();
    }

    static async getEfficiencyRangesWithIeClass() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getEfficiencyRangesWithIeClass();
        else
            return await _RESTController.getEfficiencyRangesWithIeClass();
    }

    static isRunningAsAnOfflineApplication() {
        if (!navigator.onLine && !this.hostReachable())//TODO: Trzeba też sprawdzić, czy jest to aplikacja
            return true
        else
            return false;
    }

    static hostReachable() {
        // Handle IE and more capable browsers
        let xhr = new ( window.ActiveXObject || XMLHttpRequest )( "Microsoft.XMLHTTP" );

        // Open new request as a HEAD to the root hostname with a random param to bust the cache
        xhr.open( "HEAD", "//" + window.location.hostname + "/?rand=" + Math.floor((1 + Math.random()) * 0x10000), false );

        // Issue request and handle response
        try {
            xhr.send();
            return ( xhr.status >= 200 && (xhr.status < 300 || xhr.status === 304) );
        } catch (error) {
            return false;
        }
    }

    static getUserToken() {
        let form = new FormData();

        if (localStorage.userApplicationToken)
            form.append('Authorization', localStorage.userApplicationToken);
        else
            form.append('Authorization', "");

        return form;
    }

    static async getLastEvent() {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.getLastEvent();
        else
            return await _RESTController.getLastEvent();
    }

    static async logChoiceTime(data) {
        if (this.isRunningAsAnOfflineApplication())
            return _LocalDatabaseController.logChoiceTime(data);
        else
            return await _RESTController.logChoiceTime(data);
    }

    static async loadRequiredData(store) {
        console.log("loadingData");
        window.localStorage.setItem('application_data_loaded', false);

        return new Promise(function (resolve, reject) {
            let tasks = [];

            function checkIfFulfilled() {

                tasks.push(true);
                if(tasks.length > 33) {
                    resolve();
                }
            }

            this.getMaterialSortList().then(
                function (response) {
                    store.state.appMaterialSortList = this.manageReturnedData(response, []);
                    console.log("Loaded MaterialSortList");

                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })


            this.getMeasurementsList().then(
                function (response) {
                    let appMeasurementsList = this.manageReturnedData(response, []);
                    let appMeasurementsListAsoc = {};

                    for (let curentMeasurement of appMeasurementsList) {
                        curentMeasurement.characteristic = {};
                        curentMeasurement.outlet_a = parseFloat(curentMeasurement.outlet_a);
                        curentMeasurement.outlet_b = parseFloat(curentMeasurement.outlet_b);
                        curentMeasurement.range_max = parseFloat(curentMeasurement.range_max);
                        curentMeasurement.range_min = parseFloat(curentMeasurement.range_min);

                        if (curentMeasurement.hasOwnProperty("id") && curentMeasurement.hasOwnProperty("measurement_number")) {
                            appMeasurementsListAsoc[curentMeasurement['id']] = curentMeasurement;
                        }
                    }

                    console.log("Loaded appMeasurementsList");

                    this.getFanCharacteristicsList().then(
                        function (response) {
                            let appCharacteristicsList = this.manageReturnedData(response, []);

                            for (let characteristic of appCharacteristicsList) {
                                if (appMeasurementsListAsoc[characteristic['id_measurement']] && appMeasurementsListAsoc[characteristic['id_measurement']].hasOwnProperty("characteristic")) {
                                    characteristic.a0 = parseFloat(characteristic.a0);
                                    characteristic.a1 = parseFloat(characteristic.a1);
                                    characteristic.a2 = parseFloat(characteristic.a2);
                                    characteristic.a3 = parseFloat(characteristic.a3);

                                    appMeasurementsListAsoc[characteristic['id_measurement']].characteristic[characteristic['type']] = characteristic;
                                }
                            }

                            console.log("Loaded appMeasurementsList");
                        }.bind(this)
                    ).finally(()=>{
                        checkIfFulfilled()
                    })

                    store.state.appMeasurementsList = appMeasurementsListAsoc;
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getFansTypesList().then(
                function (response) {
                    let FansTypesList = this.manageReturnedData(response, []);
                    let FansTypesListAsoc = {};

                    for (let curentFansType of FansTypesList) {
                        if (curentFansType.hasOwnProperty("id")) {
                            FansTypesListAsoc[curentFansType['id']] = curentFansType;
                        }
                    }

                    store.state.FansTypesList = FansTypesListAsoc;

                    console.log("Loaded FansTypesList");
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getConnectionsList().then(
                function (response) {
                    let ConnectionsList = this.manageReturnedData(response, []);
                    let ConnectionsListAsoc = {};

                    for (let currentConnection of ConnectionsList) {
                        if (currentConnection.hasOwnProperty("id")) {
                            ConnectionsListAsoc[currentConnection['id']] = currentConnection;
                        }
                    }

                    store.state.ConnectionsList = ConnectionsListAsoc;

                    console.log("Loaded ConnectionsList");
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getEngineStartupList().then(
                function (response) {
                    let EngineStartupList = this.manageReturnedData(response, []);
                    let EngineStartupListAsoc = {};

                    for (let currentStartupList of EngineStartupList) {
                        if (currentStartupList.hasOwnProperty("id")) {
                            EngineStartupListAsoc[currentStartupList['id']] = currentStartupList;
                        }
                    }

                    store.state.EngineStartupList = EngineStartupListAsoc;

                    console.log("Loaded EngineStartupList");
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getOctaveNoiseList().then(
                function (response) {
                    let OctaveNoiseList = this.manageReturnedData(response, []);
                    let OctaveNoiseListAsoc = {};

                    for (let currentStartupList of OctaveNoiseList) {
                        if (currentStartupList.hasOwnProperty("id")) {
                            OctaveNoiseListAsoc[currentStartupList['id']] = currentStartupList;
                        }
                    }

                    store.state.OctaveNoiseList = OctaveNoiseListAsoc;

                    console.log("Loaded OctaveNoiseList");
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getAppFansImagesList().then(
                function (response) {
                    let appFansImagesList = this.manageReturnedData(response, []);
                    let appFansImagesListAsoc = {};

                    for (let curentAppFansImage of appFansImagesList) {
                        if (curentAppFansImage.hasOwnProperty("id")) {
                            appFansImagesListAsoc[curentAppFansImage['id']] = curentAppFansImage;
                        }
                    }

                    store.state.appFansImagesList = appFansImagesListAsoc;

                    console.log("Loaded appFansImagesList");
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getFanSortList().then(
                function (response) {
                    store.state.appFanSortsList = this.manageReturnedData(response, []);
                    console.log("Loaded FanSortList");
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getAppPathsList().then(
                function (response) {
                    store.state.appPathsList = this.manageReturnedData(response, []);
                    console.log("Loaded AppPathsList");
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getAppPathsFanTypesList().then(
                function (response) {
                    store.state.appPathsFanTypesList = this.manageReturnedData(response, []);
                    console.log("Loaded AppPathsFanTypesList");
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getAppPathsParametersSettingsList().then(
                function (response) {
                    store.state.appPathsParametersSettingsList = this.manageReturnedData(response, []);
                    console.log("Loaded AppPathsParametersSettingsList");
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getAppTableParametersSettingsList().then(
                function (response) {
                    store.state.appTableParametersSettingsList = this.manageReturnedData(response, []);
                    store.state.appTableParametersSettingsList = store.state.appTableParametersSettingsList.sort((a, b) => parseInt(a.sorting) - parseInt(b.sorting))
                    console.log("Loaded AppTableParametersSettingsList");
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getAppPathsWorkPointsSettingsList().then(
                function (response) {
                    store.state.appPathsWorkPointsSettingsList = this.manageReturnedData(response, []);
                    console.log("Loaded AppPathsWorkPointsSettingsList");
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getDefaultManufacturer().then(
                function (response) {
                    store.state.defaultManufacturer = this.manageReturnedData(response, []);
                    console.log("Loaded defaultManufacturer");
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getEnginesList().then(
                function (response) {
                    store.state.enginesList = this.manageReturnedData(response, []);
                    console.log("Loaded enginesList");
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getUnitTypesList().then(
                function (response) {
                    let unitsTypes = this.manageReturnedData(response, []);
                    let unitsTypesAssoc = {};

                    for (let curentUnitType of unitsTypes) {
                        curentUnitType.list = [];

                        if (curentUnitType.hasOwnProperty("name"))
                            unitsTypesAssoc[curentUnitType['name']] = curentUnitType;
                    }

                    this.getUnitsList().then(
                        function (response) {
                            let units = this.manageReturnedData(response, []);

                            for (let unit of units) {
                                if (unitsTypesAssoc.hasOwnProperty(unit['type']))
                                    unitsTypesAssoc[unit['type']].list.push(unit);
                            }

                            store.state.unitsList = unitsTypesAssoc;
                            window.unitsList = store.state.unitsList;
                            console.log("Loaded unitsList");
                            this.loadUnitsToParameters(store);

                        }.bind(this)
                    ).finally(()=>{
                        checkIfFulfilled()
                    })

                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getPricesList().then(
                function (response) {
                    store.state.pricesList = this.manageReturnedData(response, []);
                    console.log("Loaded pricesList");
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getFansAtexesList().then(
                function (response) {
                    store.state.atexesList = this.manageReturnedData(response, []);
                    console.log("Loaded fansAtexesList");
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getRelationsFanAtexes().then(
                function (response) {
                    store.state.relationsFanAtexes = this.manageReturnedData(response, []);
                    console.log("Loaded relationsFanAtexes");
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getFansVersionsList().then(
                function (response) {
                    store.state.fansVersionsList = this.manageReturnedData(response, []);
                    console.log("Loaded fansVersionsList");
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getFansExtrasList().then(
                function (response) {
                    store.state.fansExtrasList = this.manageReturnedData(response, []);
                    console.log('Loaded fansExtrasList');
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getRelationsFanVersionsExtrasList().then(
                function (response) {
                    store.state.relationsVersionsExtras = this.manageReturnedData(response, []);
                    console.log('Loaded relationsFanVersionsExtrasList');
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getRelationsFanTypesPositionsList().then(
                function (response) {
                    store.state.relationsFanTypesPositionsList = this.manageReturnedData(response, []);
                    console.log('Loaded relationsFanTypesPositionsList');
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getFansPositionsList().then(
                function (response) {
                    store.state.fansPositionsList = this.manageReturnedData(response, []);
                    console.log('Loaded fansPositionsList');
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            // MVS-91
            this.getSettingsFullList().then(
                function (response) {
                    store.state.appSettings = this.manageReturnedData(response, []);
                    console.log('Loaded appSettingsList');
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getVariablesFullList().then(
                function (response) {
                    store.state.appVariables = this.manageReturnedData(response, []);
                    console.log('Loaded appVariablesList');
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getLastEvent().then(
                function(response) {
                    let data = response.data;
                    store.state.events.stamp = data.stamp;
                    store.state.events.description = data.description;
                    store.state.events.needReload = false;
                    store.state.events.userId = data.r_user_id;
                    console.log('Loaded lastEventStamp')
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getOfferSurchargesOptions().then(
                function (response) {
                    store.state.offerSurcharges = this.manageReturnedData(response, []);
                    console.log('Loaded offerSurcharges');
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            // NVS-95
            this.getOfferDiscountsOptions().then(
                function (response) {
                    store.state.offerDiscounts = this.manageReturnedData(response, []);
                    console.log('Loaded offerDiscounts');
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            // NVS-152
            this.getOfferAntiCorrosionOptions().then(
                function (response) {
                    store.state.offerAntiCorrosion = this.manageReturnedData(response, []);
                    console.log('Loaded offerAntiCorrosion');
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getCurrenciesList().then(
                function (response) {
                    store.state.currenciesList = this.manageReturnedData(response, []);
                    console.log('Loaded currenciesList');
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getFansAtexTypes().then(
                function(response) {
                    store.state.fansInAtexTypes = this.manageReturnedData(response, []);
                    console.log('Loaded fansAtexTypes');
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getEfficiencyRangesWithIeClass().then(
                function(response) {
                    store.state.engineEfficiencyRanges = this.manageReturnedData(response, []);
                    console.log('Loaded efficiencyRangesWithIeClass');
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })

            this.getTemperatureRangesWithManufacturers().then(
                function(response) {
                    store.state.engineTemperatureRanges = this.manageReturnedData(response, []);
                    console.log('Loaded engineTemperatureRanges');
                }.bind(this)
            ).finally(()=>{
                checkIfFulfilled()
            })
        }.bind(this));
    }

    static loadUnitsToParameters(store) {
        console.log("loadUnitsToParameters");

        for (let param in store.state.fourthStepParameters) {
            if (store.state.fourthStepParameters[param].hasOwnProperty("options")) {
                let parameter = store.state.fourthStepParameters[param];

                for (let optionId in parameter.options) {
                    let option = parameter.options[optionId];

                    if (option.type == 'select' && option.hasOwnProperty("unitType")) {
                        option.elements = [];
                        if (store.state.ValueUnitMap[option['unitType']] && store.state.ValueUnitMap[option['unitType']].value == option['unitType'] && store.state.ValueUnitMap[option['unitType']].units.length > 0) {
                            Object.assign(option.elements, store.state.ValueUnitMap[option['unitType']].units);
                        } else if (store.state.unitsList[store.state.ValueUnitMap[option['unitType']].value].list) {
                            for (let unitType of store.state.unitsList[store.state.ValueUnitMap[option['unitType']].value].list) {
                                let tmpUnitType = {};
                                tmpUnitType.value = unitType.designation;
                                tmpUnitType.unit = unitType;

                                if (unitType.flag_default == 1) {
                                    tmpUnitType.active = true;
                                    store.state.ValueUnitMap[option['unitType']].selected = tmpUnitType;
                                } else {
                                    tmpUnitType.active = false;
                                }
                                store.state.ValueUnitMap[option['unitType']].units.push(tmpUnitType);
                                //   option.elements.push(tmpUnitType);

                            }

                            for (let unitId in store.state.ValueUnitMap) {
                                let curUnit = store.state.ValueUnitMap[unitId]
                                if (curUnit.value == option['unitType']) {
                                    Object.assign(curUnit.units, store.state.ValueUnitMap[option['unitType']].units);
                                    curUnit.selected = store.state.ValueUnitMap[option['unitType']].selected;
                                }
                            }

                            Object.assign(option.elements, store.state.ValueUnitMap[option['unitType']].units);
                        }
                    }
                }
            }

        }

        // NVS-78 Załadowanie jednostek do kalkulatora jednostek normalnych
        for (let param in store.state.calculatorParameters) {
            if (store.state.calculatorParameters[param].hasOwnProperty("options")) {
                let parameter = store.state.calculatorParameters[param];

                for (let optionId in parameter.options) {
                    let option = parameter.options[optionId];

                    if (option.type == 'select' && option.hasOwnProperty("unitType")) {
                        option.elements = [];
                        if (store.state.ValueUnitMap[option['unitType']] && store.state.ValueUnitMap[option['unitType']].value == option['unitType'] && store.state.ValueUnitMap[option['unitType']].units.length > 0) {
                            Object.assign(option.elements, store.state.ValueUnitMap[option['unitType']].units);
                        } else if (store.state.unitsList[store.state.ValueUnitMap[option['unitType']].value].list) {
                            for (let unitType of store.state.unitsList[store.state.ValueUnitMap[option['unitType']].value].list) {
                                let tmpUnitType = {};
                                tmpUnitType.value = unitType.designation;
                                tmpUnitType.unit = unitType;

                                if (unitType.flag_default == 1) {
                                    tmpUnitType.active = true;
                                    store.state.ValueUnitMap[option['unitType']].selected = tmpUnitType;
                                } else {
                                    tmpUnitType.active = false;
                                }
                                store.state.ValueUnitMap[option['unitType']].units.push(tmpUnitType);
                                //   option.elements.push(tmpUnitType);

                            }

                            for (let unitId in store.state.ValueUnitMap) {
                                let curUnit = store.state.ValueUnitMap[unitId]
                                if (curUnit.value == option['unitType']) {
                                    Object.assign(curUnit.units, store.state.ValueUnitMap[option['unitType']].units);
                                    curUnit.selected = store.state.ValueUnitMap[option['unitType']].selected;
                                }
                            }

                            Object.assign(option.elements, store.state.ValueUnitMap[option['unitType']].units);
                        }
                    }
                }
            }

        }

        this.loadAllUnasugnedUnits(store);

    }

    static loadAllUnasugnedUnits(store) {
        for (let unitId in store.state.ValueUnitMap) {
            if (store.state.ValueUnitMap.hasOwnProperty(unitId)) {
                let unit = store.state.ValueUnitMap[unitId];

                if (unit.value != "" && unit.value != "-" && unit.selected == null && store.state.unitsList[unit.value] && store.state.unitsList[unit.value].list) {
                    console.log("UNASIGNED: ", unitId);
                    for (let unitType of store.state.unitsList[unit.value].list) {
                        let tmpUnitType = {};
                        tmpUnitType.value = unitType.designation;
                        tmpUnitType.unit = unitType;

                        if (unitType.flag_default == 1) {
                            tmpUnitType.active = true;
                            store.state.ValueUnitMap[unitId].selected = tmpUnitType;
                        } else {
                            tmpUnitType.active = false;
                        }

                        store.state.ValueUnitMap[unitId].units.push(tmpUnitType);
                    }
                }
            }
        }
    }
}

export {APIController};
